import { compose } from 'recompose';

import MetaShow from './MetaShow';

const enhance = compose();

export default enhance(MetaShow);
